module.exports = __webpack_public_path__ + "static/media/carro_2.581d35b7.png";